export default __webpack_public_path__ + "static/Alife-Orbs-2-f9634915f230af1d94da40bb36156fd1.png";